import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

export const certificateService = {
  listAdmin: (p: { page?: number; limit?: number; search?: string; status?: string } = {}) => {
    const params = new URLSearchParams({ page: String(p.page ?? 1), limit: String(p.limit ?? 15) })
    if (p.search) params.append('search', p.search)
    if (p.status) params.append('status', p.status)
    return restClient.get(`${endpoints.certificate.listAdmin}?${params}`).then(r => r.data)
  },
  list: (p: { page?: number; limit?: number; search?: string; status?: string } = {}) => {
    const params = new URLSearchParams({ page: String(p.page ?? 1), limit: String(p.limit ?? 15) })
    if (p.search) params.append('search', p.search)
    if (p.status) params.append('status', p.status)
    return restClient.get(`${endpoints.certificate.list}?${params}`).then(r => r.data)
  },
  addRequest:          (data: Record<string, unknown>) => restClient.post(endpoints.certificate.addRequestByAdmin, data).then(r => r.data),
  updatePaymentStatus: (data: Record<string, unknown>) => restClient.post(endpoints.certificate.updatePaymentStatus, data).then(r => r.data),
  updateStatus:        (data: Record<string, unknown>) => restClient.post(endpoints.certificate.updateRequestStatus, data).then(r => r.data),
}
